// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "knew-cb994.firebaseapp.com",
  "projectId": "knew-cb994",
  "storageBucket": "knew-cb994.firebasestorage.app",
  "messagingSenderId": "761641658845",
  "appId": "1:761641658845:web:b14ad9691e77764e64ae34",
  "measurementId": "G-QQ1JQ2G3RZ",
  "apiKey": "AIzaSyCU36AuOkRcD5V1METUS77L4DcLofVseGM"
};
